import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Image,
  CardBody,
  Card,
} from "react-bootstrap";
import webdev from "../../../../Assets/Images/services/WebDevelopment/Web-Development.png";
import {
  deliverablesWebDevelopment,
  featuresweb,
  toolsweb,
} from "../../../../Constants/content";
import { LuArrowUpRight } from "react-icons/lu";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
} from "../../../../Constants/Colors";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";

const WebDevelopment = () => {
  const designExp = [
    {
      id: 1,
      content: "Load fast, work everywhere",
    },
    {
      id: 2,
      content: "Scale with your business",
    },
    {
      id: 3,
      content: "Stay secure & future-proof",
    },
  ];

  const services = [
    {
      id: 1,
      title: " Wireframes & User Flow",
      quote: " Once we know the “why,” we map out the “how.”",
      description:
        "  We sketch low-fidelity wireframes that bring structure to ideas. These blueprints focus on user flow, usability, and information hierarchy—setting the stage for an intuitive user experience.",
      subHead: "Key Activities",
      buttons: [
        {
          id: 1,
          btnText: "Information Architecture",
        },
        {
          id: 2,
          btnText: "Userflow Diagrams",
        },
        {
          id: 3,
          btnText: "Wireframe design (Lo-Fi + Mid-Fi)",
        },
        {
          id: 4,
          btnText: " Interaction Strategy",
        },
      ],
    },
    {
      id: 2,
      title: "Deep-Dive User Research",
      quote: "Before We Push Pixels, We Dive Into The Minds Of Your Users.",
      description:
        "Through Interviews, Surveys, Competitor Analysis, And Real-World Behavior Tracking, We Decode What Your Audience Truly Needs. This Lays The Groundwork For Informed Design Decisions—No Guesswork, Just User-Driven Clarity.",
      subHead: "Key Activities:",
      buttons: [
        { id: 1, btnText: "Market & Competitor Analysis" },
        { id: 2, btnText: "Persona Creation" },
        { id: 3, btnText: "Journey Mapping" },
        { id: 4, btnText: "UX Audit" },
      ],
    },
    {
      id: 3,
      title: "Visual Design & Prototyping",
      quote: "Now Comes The Glow–Up.",
      description:
        "We Craft Visually Stunning, Brand-Aligned UI Elements That Elevate User Trust And Engagement. Every Screen Is Designed With Pixel-Perfect Precision—And We Bring It To Life Through Interactive Prototypes.",
      subHead: "Key Activities:",
      buttons: [
        { id: 1, btnText: "UI Moodboards & Style Guides" },
        { id: 2, btnText: "High-Fidelity Mockups" },
        { id: 3, btnText: "Clickable Prototypes (Figma/Adobe XD)" },
      ],
    },
    {
      id: 4,
      title: "Usability Testing & Handoff",
      quote: "We Test. We Tweak. We Perfect.",
      description:
        "Before Handoff, We Validate The Designs With Real Users To Catch Friction Points And Improve Flows. After Testing, We Deliver Dev-Ready Files And Work Closely With Your Tech Team For A Smooth Implementation.",
      subHead: "Key Activities:",
      buttons: [
        { id: 1, btnText: "A/B Testing & Heatmaps" },
        { id: 2, btnText: "Design-To-Dev Handoff" },
        { id: 3, btnText: "Usability Testing" },
        { id: 4, btnText: "Design Documentation" },
      ],
    },
  ];

  return (
    <>
      <Container className="my-5">
        <div className="text-center mb-4">
          <Button
            variant="primary"
            className="mb-3"
            style={{ borderRadius: "30px" }}
          >
            Web Development
          </Button>
          <h1 className="fw-bold" style={{ color: primaryColor }}>
            Quality Code & Reliable Tech
          </h1>
          <p className="fw-semibold text-muted">
            Code That Powers Real-World Impact
          </p>
          <Button
            style={{
              backgroundColor: secondaryColor,
              color: textDarkColor,
              border: "none",
            }}
            className="rounded-pill my-2 px-4"
          >
            interact with our experts <LuArrowUpRight className="fs-5" />
          </Button>
        </div>

        <Row className="d-flex align-items-center my-5 mx-auto gap-0 gap-lg-5 justify-content-center">
          <Col md={9} lg={8}>
            <h3 className="fw-bold mb-3" style={{ color: primaryColor }}>
              Why Quality Service Isn’t Optional Anymore
            </h3>
            <p className="text-muted">
              Modern businesses demand more than just a pretty website. Whether
              you're a startup or an enterprise, your website is the foundation
              of your digital presence. From blazing-fast performance to
              scalable architecture—your site must do it all.
            </p>
            <h5 className="fw-bold">At Ideal, We Build Websites That:</h5>
            <ul className="list-unstyled">
              {designExp.map((exp, index) => {
                return (
                  <li key={index} className="mb-2 d-flex align-items-center">
                    <span
                      className=""
                      style={{
                        background:
                          "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                        WebkitMaskImage:
                          "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskSize: "cover",
                        display: "inline-block",
                        width: "18px",
                        height: "18px",
                      }}
                    ></span>
                    &nbsp; {exp.content}
                  </li>
                );
              })}
            </ul>
            <p className="text-muted">
              Whether you're launching a brand-new platform or upgrading your
              legacy site—we build with precision and purpose.
            </p>
          </Col>
          <Col xs={7} md={3} className="text-center p-0">
            <Image
              src={webdev}
              alt="Design Illustration"
              className="rounded"
              fluid
            />
          </Col>
        </Row>

        <Row>
          <Col md={10}>
            <h3>
              {" "}
              Our{" "}
              <span style={{ color: primaryColor }}>
                Web Development Process:
              </span>
            </h3>
            <h6 className="fw-bold mb-3">
              Strategy-Led, Speed-Focused, Scalable by Nature
            </h6>
            <p className="text-muted">
              We don’t just code pages—we engineer solutions. Our process is
              backed by tech strategy, real-user behavior, and agile iterations.
              Whether it’s mobile-first design, SEO-optimized architecture, or
              backend efficiency—we build it right from the ground up.
            </p>
          </Col>
        </Row>

        <div className="px-0 px-md-3">
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            spaceBetween={20}
            pagination={{
              clickable: true,
              el: ".custom-pagination",
            }}
            navigation={{
              nextEl: ".custom-next",
              prevEl: ".custom-prev",
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                centeredSlides: false,
              },
              768: {
                slidesPerView: "auto",
                centeredSlides: true,
              },
            }}
            className="mySwiper py-1"
          >
            {services.map((service, index) => {
              return (
                <SwiperSlide key={index} style={{ maxWidth: "700px" }}>
                  <div
                    style={{
                      padding: "2px",
                      borderRadius: "20px",
                      background: `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`,
                    }}
                  >
                    <Card
                      style={{
                        border: "none",
                        color: textDarkColor,
                        cursor: "pointer",
                        borderRadius: "18px",
                      }}
                      className="overflow-hidden"
                    >
                      <CardBody>
                        <Row className="align-items-center d-flex">
                          <Col xs={12} md={9}>
                            <h5 style={{ color: primaryColor }}>
                              {service.title}
                            </h5>
                            <p
                              className="mb-0 fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {service.quote}
                            </p>
                            <p
                              className="text-muted text-justify"
                              style={{ fontSize: "14px" }}
                            >
                              {service.description}
                            </p>
                          </Col>
                          <Col xs={6} md={3} className="m-auto">
                            <Image src={webdev} fluid />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <h6 style={{ fontSize: "14px" }}>
                              {service.subHead}
                            </h6>
                          </Col>
                          <Col>
                            {service.buttons.map((btn, index) => {
                              return (
                                <Button
                                  key={index}
                                  variant="outline-dark"
                                  className="rounded-pill btn-sm me-1 mt-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  {btn.btnText}
                                </Button>
                              );
                            })}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="d-flex flex-row justify-content-center align-items-center mt-3 gap-3">
            <div className="custom-prev px-2 px-md-3">
              <GrLinkPrevious />
            </div>
            <div className="custom-pagination d-flex gap-2 w-auto mt-1 mt-md-2" />
            <div className="custom-next px-2 px-md-3">
              <GrLinkNext />
            </div>
          </div>
        </div>

        <Row
          className="align-items-start flex-column flex-md-row py-5 my-5"
          style={{
            backgroundColor: " #C8E6F5",
          }}
        >
          {/* Left Title Section */}
          <Col
            md={4}
            className="justify-content-center align-items-center d-flex my-auto"
          >
            <div className="text-center text-md-start">
              <h1 style={{ color: primaryColor }}>Our Key</h1>
              <h1>Deliverables</h1>
            </div>
          </Col>

          {/* Right Scrollable Deliverables */}
          <Col md={8}>
            <div className="scrollbox">
              {deliverablesWebDevelopment.map((item, index) => (
                <div key={item.id} className="mb-5">
                  <div className="d-flex flex-column align-items-start">
                    <h5
                      className="fw-light mb-2"
                      style={{ fontSize: "1.25rem", color: primaryColor }}
                    >
                      {item.id}
                    </h5>
                    <h3
                      className="fw-bold text-dark mb-2"
                      style={{ fontSize: "1.5rem" }}
                    >
                      {item.title}
                    </h3>
                  </div>

                  <p className="fst-italic fw-semibold text-muted mb-2">
                    {item.subtitle}
                  </p>
                  <p className="text-muted text-justify">{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        <Container className="my-5">
          {/* Section Title */}
          <h2
            className="fw-bold text-start mb-5"
            style={{ color: primaryColor }}
          >
            Why Brands Choose Ideal
          </h2>

          {/* Features Section */}
          {featuresweb.map((feature, index) => (
            <Row
              className={`align-items-center justify-content-center mb-3 ${
                index % 2 !== 0 ? "flex-md-row-reverse" : ""
              }`}
              key={index}
            >
              <Col md={6} className="mb-4 mb-md-0">
                <h5 className="fw-bold" style={{ color: primaryColor }}>
                  {feature.title}
                </h5>
                <p className="text-muted text-justify">{feature.desc}</p>
              </Col>
              <Col xs={7} md={4} className="text-center">
                <Image
                  src={feature.img}
                  alt={feature.title}
                  fluid
                  style={{ objectFit: "contain" }}
                />
              </Col>
            </Row>
          ))}

          {/* UI/UX Design Stack */}
          <div className="mt-5 text-center">
            <h4 className="fw-bold mb-3" style={{ color: primaryColor }}>
              Our Web Development Tech Stack
            </h4>
            <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
              We combine creativity with clean code to deliver high-performance websites and platforms. Whether you're building a marketing site, CMS, portal, or SaaS product—we choose the right tech to bring your vision to life.
            </p>
          </div>

          {/* Design Tools */}
          <div className="mt-4 text-center">
            <h5 className="fw-bold mb-4" style={{ color: primaryColor }}>
              Design Tools & Frameworks We Work With
            </h5>
            <Row className="justify-content-center">
              {toolsweb.map((tool, index) => (
                <Col
                  key={index}
                  xs={4}
                  sm={3}
                  md={2}
                  className="mb-4 text-center"
                >
                  <Image
                    src={tool.img}
                    alt={tool.name}
                    fluid
                    style={{ maxHeight: "50px", marginBottom: "10px" }}
                  />
                  <div className="small">{tool.name}</div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </Container>
    </>
  );
};

export default WebDevelopment;
